/**
 * A state unit (tasks/state-mode.md) has no referrals and no patient app, so their inbox items are not shown for it,
 * even ones that arrived before it became a unit. Documents and tasks stay.
 */
export function visibleInboxItems<T extends { type?: string; groupId?: string }>(items: T[], unitGroupIds: Set<string>): T[] {
  if (!unitGroupIds.size) return items;
  return items.filter((item) => {
    const outside = /^(referral-|patient-app-)/.test(item.type || '');
    return !(outside && item.groupId && unitGroupIds.has(item.groupId));
  });
}
